import { FC, useEffect, useState } from 'react';

import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import useSetActivationOnboardingCompleted from 'common/hooks/useSetActivationOnboardingCompleted/useSetActivationOnboardingCompleted';
import SunshineModal from 'components/_core/SunshineModal';
import MultipleCardPanel, {
  MultipleCardPanelItem,
} from 'components/MultipleCardPanel';
import { usePostOnboardingAccountSetupContext } from 'features/PostOnboardingAccountSetup/context';

import cardImg from '../../../../assets/brand/credit-card.png';
import fireworksImg from '../../../../assets/brand/fireworks.png';
import folderImg from '../../../../assets/brand/folder.png';
import locales from './locales';

const userActionItems: MultipleCardPanelItem[] = [
  {
    color: 'blue.100',
    img: cardImg,
    name: 'buy',
    title: locales.advantages.buy as string,
  },
  {
    color: 'green.100',
    img: folderImg,
    name: 'anticipate',
    title: locales.advantages.anticipate as string,
  },
  {
    color: 'orange.100',
    img: fireworksImg,
    name: 'develop',
    title: locales.advantages.develop as string,
  },
];

const SetupCompletedModal: FC = () => {
  const { allActionsCompleted, hasCompletedPostOnboardingSetup } =
    usePostOnboardingAccountSetupContext();

  const { canAccessFeature } = useCanCompanyUserAccessFeature();
  const canAccessActivation = canAccessFeature({
    name: FeatureName.Activationonboarding,
  });

  const shouldShowCompletedPostOnboardingModal =
    canAccessActivation &&
    allActionsCompleted &&
    !hasCompletedPostOnboardingSetup;

  const [isModalOpen, setIsModalOpen] = useState(
    shouldShowCompletedPostOnboardingModal,
  );

  useEffect(() => {
    setIsModalOpen(shouldShowCompletedPostOnboardingModal);
  }, [shouldShowCompletedPostOnboardingModal]);

  const [setOnboardingCompleted] = useSetActivationOnboardingCompleted();

  const onModalClose = async () => {
    await setOnboardingCompleted();
    setIsModalOpen(false);
  };

  return (
    <SunshineModal isOpen={isModalOpen} onClose={onModalClose}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>

        <MultipleCardPanel items={userActionItems} marginTop="space-16" />
      </SunshineModal.Body>
    </SunshineModal>
  );
};

export default SetupCompletedModal;
